module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("iFOQB"))).then(() => parcelRequire('ftvw9'));